<template>
  <svg
    width="100%"
    height="100%"
    viewBox="0 0 60 60"
    version="1.1"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    xmlns:xlink="http://www.w3.org/1999/xlink"
  >
    <title>Icon_hangup</title>
    <g id="Icon_hangup" stroke="none" stroke-width="1">
      <g id="Group-4" transform="translate(5.000000, 10.000000)" fill-rule="inherit">
        <path
          id="Fill-100"
          d="M48.7561751,7.28638358 C49.01488,7.69523232 49.3199425,8.08461207 49.5233174,8.52041787 C49.7311786,8.96820459 49.9599755,9.4579245 49.9704433,9.93566351 C50.006333,11.5156467 50.0332503,13.1046156 49.9031501,14.6771108 C49.7670683,16.2945344 49.0238524,17.6618563 47.4955493,18.3792137 C46.7792506,18.7161769 45.9537875,18.933331 45.1657094,18.9782594 C42.7072649,19.1190352 40.3116272,18.7161769 38.035622,17.7592013 C35.7970018,16.8157042 34.6096508,15.0799691 34.3853402,12.6733027 C34.3449643,12.2419897 34.3060837,11.8076815 34.318047,11.374871 C34.3344964,10.7264039 34.0174707,10.3010814 33.489593,9.9970657 C32.6177723,9.49236964 31.6502458,9.28270362 30.670756,9.16139685 C26.7617693,8.679165 22.8497917,8.68365784 18.9452912,9.21531097 C17.941875,9.35159388 16.9519174,9.57623604 16.066638,10.1183725 C15.5731546,10.419393 15.356321,10.8282417 15.3308991,11.4197994 C15.2845416,12.5115603 15.2456611,13.6167998 15.0512586,14.6890917 C14.6011419,17.1796245 13.1102238,18.8614455 10.7744024,19.7854736 C9.2356314,20.3920075 7.62657642,20.6675685 5.97565012,20.6525924 C2.83081497,20.6256353 0.885294038,19.011207 0.264701272,15.9216284 C-0.136067068,13.9298012 -0.0373703873,11.9259931 0.266196677,9.94015635 C0.47106706,8.59979144 1.33989693,7.59788738 2.28648783,6.68733781 C4.16022936,4.88421004 6.41679438,3.70259225 8.80794578,2.76658323 C13.0010593,1.1237002 17.3825938,0.361414458 21.8568433,0.100829547 C26.8918694,-0.192702881 31.8820334,0.139767522 36.800418,1.29442825 C39.9721705,2.037245 43.025786,3.09755602 45.7997609,4.84826729 C46.4039042,5.22866135 46.969167,5.66746238 47.5508792,6.07930635 L48.7561751,7.28638358 Z"
        />
        <path
          id="Fill-102"
          d="M17.2554844,26.3787211 L31.3601374,40.5042204 C32.8929267,42.0392752 35.2721149,39.6580683 33.7393255,38.1215159 C29.0377746,33.4130161 24.3362236,28.7045163 19.6346726,23.9960166 C18.1018832,22.4609618 15.7211997,24.8421687 17.2554844,26.3787211"
        />
        <path
          id="Fill-104"
          d="M31.3604364,23.9963161 C26.6588855,28.7048159 21.9573345,33.4133156 17.2557835,38.1218154 C15.7214987,39.6568702 18.1006869,42.0395748 19.6349717,40.50452 L33.7396246,26.3790207 C35.272414,24.8424683 32.8932258,22.4597637 31.3604364,23.9963161"
        />
      </g>
    </g>
  </svg>
</template>

<script lang="ts">
import { Component, Vue } from 'vue-property-decorator';
@Component
export default class HangupIcon extends Vue {}
</script>
